import { Component, OnInit } from '@angular/core';
import { IInfo, Info } from '../../../../../core/common';
import { IV6OptionValueTranslation, V6OptionValueTranslation } from '../../../../../core/models';
import { ProductService } from '../../../../../core/services/product.service';

@Component({
  selector: 'app-add-value-translation',
  templateUrl: './add-value-translation.component.html',
  styleUrls: ['./add-value-translation.component.scss']
})
export class AddValueTranslationComponent implements OnInit {

  constructor(private productService: ProductService) { }
  productCode = [];
  dummyProductCode = [];
  ngOnInit() {
    this.productService.GetProductCode().subscribe(productCodeResponse => {
      this.productCode = productCodeResponse;
      this.dummyProductCode = this.productCode;
    });
  }

  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  addValueTranslation: IV6OptionValueTranslation = new V6OptionValueTranslation();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();


  validateForm(): boolean {
    return true;
  }


  public value: any = [];
  handleFilter(event) {
    let keys = Array.from(this.dummyProductCode.values());
    this.productCode = keys.filter(
      (s) => s ? s.toLowerCase().indexOf(event.toLowerCase()) !== -1:false
    );
  }
  addValueTranslationToSave(): void {
    this.isSubmitted = true;
    if (this.value) {
      this.addValueTranslation.optionValueApplicableProducts = this.value.join("|");
    }
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;
    this.productService.AddValueTranslation(this.addValueTranslation).subscribe(response => {
      if (response) {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }
      this.addValueTranslation = new V6OptionValueTranslation();
      this.value = [];
    });
  }
}
